const ImageKeyEnum = Object.freeze({
    COMPANY_PRINTABLE_LOGO: 'company-printable-logo',

    // This is always appended with "--{branchID}" when used.
    BRANCH_PRINTABLE_LOGO: 'branch-printable-logo',
});

module.exports = ImageKeyEnum;
